export default __webpack_public_path__ + "static/media/gst_template.5ccdaf19.xlsx";